export default __webpack_public_path__ + "static/media/sqlite_editor.c5211378.PNG";